import { Platform } from 'react-native';
import type { VideoPlayer } from 'expo-video';

/**
 * Subscribe to statusChange and auto-play when the player becomes ready.
 * On web, applies a delay before playing to work around autoplay policies.
 * Returns the subscription for cleanup.
 */
export function subscribeAutoPlay(
  player: VideoPlayer,
  isPaused: () => boolean,
  webDelayMs: number = 500,
) {
  return player.addListener('statusChange', (payload) => {
    if (payload.status === 'readyToPlay') {
      if (Platform.OS === 'web') {
        setTimeout(() => {
          if (!isPaused()) player.play();
        }, webDelayMs);
      } else {
        if (!isPaused()) player.play();
      }
    }
  });
}
